import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { checklistAPI } from '../../services/api';

const WidgetCompletude = ({ dossierId, refreshTrigger }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (dossierId) {
      loadStats();
    }
  }, [dossierId, refreshTrigger]);

  const loadStats = async () => {
    try {
      const res = await checklistAPI.getStats(dossierId);
      setStats(res.data);
    } catch (error) {
      console.error('Erreur chargement stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-gray-400">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span className="text-sm">Chargement...</span>
      </div>
    );
  }

  if (!stats) return null;

  const { total, recus, completude } = stats;

  // Couleur selon le niveau de complétude
  const getBarColor = () => {
    if (completude >= 100) return 'bg-green-500';
    if (completude >= 75) return 'bg-blue-500';
    if (completude >= 50) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getTextColor = () => {
    if (completude >= 100) return 'text-green-600';
    if (completude >= 75) return 'text-blue-600';
    if (completude >= 50) return 'text-yellow-600';
    return 'text-red-600';
  };

  return (
    <div className="flex items-center gap-3 bg-white px-4 py-2 rounded-lg border border-gray-200">
      <span className="text-sm font-medium text-gray-600 whitespace-nowrap">Complétude:</span>
      <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden min-w-[100px]">
        <div 
          className={`h-full ${getBarColor()} transition-all duration-500`}
          style={{ width: `${completude}%` }}
        />
      </div>
      <span className={`text-sm font-bold ${getTextColor()} whitespace-nowrap`}>
        {completude}% ({recus}/{total})
      </span>
    </div>
  );
};

export default WidgetCompletude;
